export default __webpack_public_path__ + "static/media/autofarm-white.f2f85bd1.svg";